document.addEventListener('DOMContentLoaded', () => {
    const optimizerForm = document.getElementById('optimizerForm');

    if (optimizerForm) {
        optimizerForm.addEventListener('submit', (event) => {
            event.preventDefault(); // Impedisce il comportamento predefinito di submit

            const fileUpload = document.getElementById('fileUpload');
            const file = fileUpload.files[0];

            if (file) {
                const formData = new FormData();
                formData.append('file-upload', file);

                fetch( WPURLS.ajaxUrl, {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.text())
                .then(data => {
                    document.getElementById('optimizerFormFooter').insertAdjacentHTML('beforeend', data);
                })
                .catch(error => {
                    console.error('Errore nella richiesta di ottimizzazione:', error);
                });
            }
        });
    }
});
